/*
 * Div1InputEmail.js: This component renders the input field and the Search button.
 *
 * The input field is used to enter the user's email address.
 * The email address must end with @nike.com or @converse.com.
 * Additionally, when a user starts typing after having searched, Div2, Div3, and Div4 state is cleared.
 */

import React, { useEffect, useRef } from "react";
import isUsernameValid from "../../utils/isUsernameValid";
import { useApiActivity } from "../../contexts/ApiActivityContext";
import "./Div1InputEmail.css";

const Div1InputEmail = ({
  retailGIDsearch,
  enteredEmail,
  setEnteredEmail,
  Div1SearchButtonClicked,
  setUserInfo,
  setDiv2Visible,
  onEditAfterSearch = null,
  activeStep,
}) => {
  const { isActive } = useApiActivity();
  const submittedEmailRef = useRef("");
  const hasClearedEditingRef = useRef(false);

  // Clear downstream state once when the user edits after a previous search
  useEffect(() => {
    const hasSearched = submittedEmailRef.current !== "";
    const isEditing = enteredEmail !== submittedEmailRef.current;

    if (hasSearched && isEditing && !hasClearedEditingRef.current) {
      if (onEditAfterSearch) {
        onEditAfterSearch();
      } else {
        setUserInfo({});
        setDiv2Visible(false);
      }
      hasClearedEditingRef.current = true;
    }
  }, [enteredEmail, onEditAfterSearch, setUserInfo, setDiv2Visible]);

  const handleInputChange = (event) => {
    setEnteredEmail(event.target.value);
  };

  const handleSearch = () => {
    submittedEmailRef.current = enteredEmail;
    hasClearedEditingRef.current = false;
    Div1SearchButtonClicked();
  };

  let isInputValid = false;
  let placeholderText = "first.last@nike.com";

  if (retailGIDsearch) {
    placeholderText = "Retail GID username";
    isInputValid = isUsernameValid("retailGID", enteredEmail);
  } else {
    isInputValid = isUsernameValid("email", enteredEmail);
  }
  return (
    <>
      <div
        className={`child-div form-div ${
          activeStep === 1 ? "active-step" : ""
        }`}
      >
        <input
          type="text"
          placeholder={placeholderText}
          value={enteredEmail}
          onChange={handleInputChange}
          onKeyDown={(e) => {
            if (
              e.key === "Enter" &&
              isInputValid &&
              !isActive
            ) {
              handleSearch();
            }
          }}
        />
        <button
          className={`app-button ${
            isInputValid && !isActive
              ? "button-valid"
              : "button-invalid"
          }`}
          disabled={!isInputValid || isActive}
          onClick={handleSearch}
        >
          Search
        </button>
      </div>
    </>
  );
};

export default Div1InputEmail;
